module.exports = __webpack_public_path__ + "static/media/complete.3360481a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Svgs/import-status-icons/complete.svg
// module id = 7681
// module chunks = 0